'use strict';

angular.module('basketModule')

.config(function (resourceStateProvider)
{
    resourceStateProvider
        .state('admin.basket', {
            url: 'basket',
            model: 'Basket',
            viewOptions: 'basketViewOptions',
            title: 'MY KITBAG',
        });
});
